import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    color: idsTokens.table.default.tableCell.color.head.label.enabled,
    borderBottom: `${idsTokens.table.default.tableCell.border.head.stroke} solid ${idsTokens.table.default.tableCell.border.head.color.enabled}`,
    backgroundColor: idsTokens.table.default.tableCell.color.head.background.enabled,
    '& th:not(.styled-header)': {
      // Apply default background only to headers without custom styling
      backgroundColor: idsTokens.table.default.tableCell.color.head.background.enabled,
      '& .MuiTableSortLabel-root.Mui-active': {
        color: idsTokens.table.default.tableCell.color.head.label.selected,
      },
    },
    '& th.styled-header': {
      // Styled headers use sx prop, no defaults needed
      '& .MuiTableSortLabel-root.Mui-active': {
        color: idsTokens.table.default.tableCell.color.head.label.selected,
      },
    },
    '& tr:first-child th.styled-header': {
      // Remove bottom border from styled header cells only; filter row keeps the border
      borderBottom: 'none',
    },
    '& th:not(.styled-header):hover': {
      backgroundColor: idsTokens.table.default.tableCell.color.head.background.hover,
      borderBottom: `${idsTokens.table.default.tableCell.border.head.stroke} solid ${idsTokens.table.default.tableCell.border.head.color.hover}`,
      '& .MuiTableSortLabel-root': {
        color: idsTokens.table.default.tableCell.color.head.label.hover,
      },
    },
    '& tr th:nth-of-type(2)': {
      '& th': {
        paddingTop: 0,
        border: 'none',
      },
    },
  },
});
